import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/NfcListSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';
const getSearchCriteria = (state) => state.nfcList.searchCriteria;

function* getListNFC({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('nfc_card')}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            },
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}
function* getHistory({ payload: { id, page, size } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('nfc_list_history')}/${id}`, {
            params: {
                page: page ? page - 1 : null,
                size
            }
        });
        yield put({ type: listActions.get_history_suceed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_history_failed.type, payload: error });
    }
}
function* addCardRegistration({ payload: { id, params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('nfc_card_user')}`, {
            ...params,
        });
        yield put({ type: listActions.add_card_registration_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Gắn thẻ thành công!');

        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.add_card_registration_failed.type, payload: error });
    }
}

function* updateCardRegistration({ payload: { id, params } }) {
    const searchCriteria = yield select(getSearchCriteria);

    try {
        const response = yield NetworkHandler.put(`${config.getUrl('nfc_card_user')}`, {
            ...params,
        });
        yield put({ type: listActions.update_card_registration_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Đổi thẻ thành công!');

        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    }
}
function* exportList({ payload }) {
    try {
        const { filters } = payload;
        const response = yield NetworkHandler.get(`${config.getUrl('nfc_card')}`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: listActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.export_list_failed.type, payload: error });
    }
}
function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getListNFC);
    yield takeLatest(listActions.get_history.type, getHistory);
    yield takeLatest(listActions.add_card_registration.type, addCardRegistration);
    yield takeLatest(listActions.update_card_registration.type, updateCardRegistration);
    yield takeLatest(listActions.export_list.type, exportList);
}

export default watchRequestDetail;
